export class ApiError extends Error {
  status: number
  code?: string
  data?: unknown

  constructor(message: string, status: number, code?: string, data?: unknown) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
    this.data = data
  }

  static isApiError(error: unknown): error is ApiError {
    return error instanceof ApiError
  }

  static isUnauthorized(error: unknown): boolean {
    return ApiError.isApiError(error) && error.status === 401
  }

  static isForbidden(error: unknown): boolean {
    return ApiError.isApiError(error) && error.status === 403
  }

  static isNotFound(error: unknown): boolean {
    return ApiError.isApiError(error) && error.status === 404
  }

  static isValidation(error: unknown): boolean {
    return ApiError.isApiError(error) && error.status === 400
  }

  static isServerError(error: unknown): boolean {
    return ApiError.isApiError(error) && error.status >= 500
  }
}

export function getErrorMessage(error: unknown): string {
  if (ApiError.isApiError(error)) {
    return error.message
  }
  if (error instanceof Error) {
    return error.message
  }
  return 'An unexpected error occurred'
}
